
import { Component, Vue, Inject } from 'vue-property-decorator'
import Empty from '@/components/Empty/index.vue'
import { getNewData, setNewData } from '@/utils/cookies'
import { AppModule } from '@/store/modules/app'
// 接口
import {
  getInformData,
  batchMsg,
  batchDeleteMsg,
  setStatus,
  getCountUnread,
} from '@/api/inform'
import { scheduleElTableFixedSync } from '@/utils/elTableFixedSync'
@Component({
  name: 'Inform',
  components: {
    Empty,
  },
})
export default class extends Vue {
  // @Inject('reload') readonly reload!: Function
  private activeIndex = 0
  private counts: number = 0
  private page: number = 1
  private pageSize: number = 10
  private status = 1
  private typeFilter: number | null = null
  private baseData = []
  private selectedIds: number[] = []
  private isSearch: boolean = false

  get typeTabs() {
    return [
      { label: '全部', value: null },
      { label: '接单', value: 1 },
      { label: '退押金', value: 6 },
      { label: '押金到期', value: 7 },
    ]
  }
  get tabList() {
    return [
      {
        label: '未读',
        value: 1,
        // num: this.ountUnread,
      },
      {
        label: '已读',
        value: 2,
        // num: 0,
      },
    ]
  }
  get ountUnread() {
    return AppModule.statusNumber
  }
  created() {
    this.getData()
  }
  mounted() {
    window.addEventListener('resize', this.scheduleTableLayout)
  }
  beforeDestroy() {
    window.removeEventListener('resize', this.scheduleTableLayout)
  }
  private scheduleTableLayout() {
    scheduleElTableFixedSync(this, 'mainTable')
  }
  // 获取列表数据
  async getData() {
    const parent: any = {
      pageNum: this.page,
      pageSize: this.pageSize,
      status: this.status,
    }
    if (this.typeFilter != null) {
      parent.type = this.typeFilter
    }
    const { data } = await getInformData(parent)
    if (data.code === 1) {
      this.baseData = (data.data.records || [])
        .filter((val: any) => Number(val.type) !== 4 && Number(val.type) !== 5)
        .map((val: any) => this.normalizeInformRow(val))
      this.selectedIds = []
      this.counts = data.data.total
      this.scheduleTableLayout()
      // this.$message.success('操作成功！')
    } else {
      this.$message.error(data.msg)
    }
  }

  // 全部已读
  async handleBatch() {
    const ids = []
    this.baseData.forEach((val) => {
      ids.push(val.id)
    })
    const { data } = await batchMsg(ids)
    if (data.code === 1) {
      // this.status = 2
      // this.activeIndex = 1
      this.getCountUnread()
      this.getData()
      // this.$message.success('操作成功！')
    } else {
      this.$message.error(data.msg)
    }
  }
  // 设置单个订单已读
  async handleSetStatus(id) {
    const { data } = await setStatus(id)
    if (data.code === 1) {
      this.getCountUnread()
      this.getData()
    } else {
      this.$message.error(data.msg)
    }
  }

  private handleSelectionChange(rows: any[]) {
    this.selectedIds = (rows || []).map((item) => Number(item.id)).filter((id) => !Number.isNaN(id))
  }

  async handleBatchDelete() {
    if (!this.selectedIds.length) return
    try {
      await this.$confirm(`确认删除选中的 ${this.selectedIds.length} 条通知吗？`, '批量删除', {
        type: 'warning',
      })
    } catch (_) {
      return
    }
    const { data } = await batchDeleteMsg(this.selectedIds)
    if (data.code === 1) {
      this.selectedIds = []
      this.getCountUnread()
      this.getData()
      this.$message.success('删除成功')
    } else {
      this.$message.error(data.msg)
    }
  }
  /** 跳转订单详情（带 orderId 会自动打开详情弹窗） */
  private orderDetailPath(item: any) {
    if (item && item.orderId) {
      return `/order?orderId=${item.orderId}`
    }
    return '/order'
  }

  /** 通知跳转：退押金 → 申请列表，其余 → 订单详情 */
  private notifyLinkPath(item: any) {
    if (item && item.type === 6) {
      const query: any = { status: '0' }
      if (item.parsed && item.parsed.orderNumber) {
        query.orderNumber = item.parsed.orderNumber
      }
      return { path: '/emptyBucketRefund', query }
    }
    return this.orderDetailPath(item)
  }

  private typeLabel(type: number) {
    const map: any = {
      1: '待接单',
      2: '紧急接单',
      3: '待派送',
      4: '催单',
      5: '今日数据',
      6: '退押金',
      7: '押金到期',
    }
    return map[type] || '通知'
  }

  private typeTagStyle(type: number) {
    if (type === 2) return 'danger'
    if (type === 4) return 'warning'
    if (type === 6) return 'success'
    if (type === 7) return 'warning'
    return 'info'
  }

  private normalizeInformRow(val: any) {
    let details: any = {}
    if (val && val.details) {
      try {
        details = typeof val.details === 'string' ? JSON.parse(val.details) : val.details
      } catch (e) {
        details = {}
      }
    }
    return {
      ...val,
      details,
      parsed: this.parseInformContent(val, details),
    }
  }

  private parseInformContent(val: any, details: any) {
    const content = (val && val.content) || ''
    const type = val && val.type
    const orderMatch = content.match(/订单号[：:]\s*(\S+)/)
    const orderNumber = orderMatch ? orderMatch[1] : ''
    const depositMatch = content.match(/押(\d+)桶[^¥]*¥([\d.]+)/)
    const userMatch = content.match(/用户(\S+)\s+(\d{11})/)

    let depositQty = depositMatch ? depositMatch[1] : ''
    let depositAmount = depositMatch ? depositMatch[2] : ''
    if (!depositQty && details) {
      depositQty = details.applyQty != null ? String(details.applyQty) : (details.depositQty != null ? String(details.depositQty) : '')
      depositAmount = details.applyAmount != null ? String(details.applyAmount) : (details.depositAmount != null ? String(details.depositAmount) : '')
    }

    const depositText = depositQty && depositAmount
      ? `${depositQty}桶 · ¥${depositAmount}`
      : (depositQty ? `${depositQty}桶` : '')

    const userName = userMatch ? userMatch[1] : ''
    const userPhone = userMatch ? userMatch[2] : (details && details.userPhone ? details.userPhone : '')
    const userText = userName || userPhone ? `${userName}${userPhone ? ' ' + userPhone : ''}`.trim() : ''

    let summary = content
    if (type === 1 || type === 2) summary = '有新订单待处理'
    else if (type === 3) summary = '订单待派送'
    else if (type === 4) summary = '客户催单，请尽快处理'
    else if (type === 5) summary = '今日经营数据汇总'
    else if (type === 6) summary = '用户申请退桶退押金'
    else if (type === 7) summary = '空桶押金将满一年，请提醒退桶'
    else summary = content.replace(/订单号[：:]\s*\S+/, '').trim() || content

    return { summary, orderNumber, depositText, userText }
  }

  // 获取未读消息
  async getCountUnread() {
    const { data } = await getCountUnread()
    if (data.code === 1) {
      AppModule.StatusNumber(data.data)
      // this.$message.success('操作成功！')
    } else {
      this.$message.error(data.msg)
    }
  }
  // 触发已读未读按钮
  handleClass(index) {
    this.activeIndex = index
    if (index === 0) {
      this.status = 1
    } else {
      this.status = 2
    }
    this.page = 1
    this.getData()
  }
  handleTypeFilter(type: number | null) {
    this.typeFilter = type
    this.page = 1
    this.getData()
  }
  private handleSizeChange(val: any) {
    this.pageSize = val
    this.getData()
  }

  private handleCurrentChange(val: any) {
    this.page = val
    this.getData()
  }
}
